import { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Stack,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PdfPreviewProps {
  url: string;
  width?: number;
  actions?: React.ReactNode;
}

export function PdfPreview({ url, width = 500, actions }: PdfPreviewProps) {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState(1);

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="body2" fontWeight={600}>PDF 預覽</Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton size="small" disabled={pageNumber <= 1} onClick={() => setPageNumber((p) => p - 1)}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <Typography variant="body2" color="text.secondary">
            {pageNumber} / {numPages || '—'}
          </Typography>
          <IconButton size="small" disabled={pageNumber >= numPages} onClick={() => setPageNumber((p) => p + 1)}>
            <ArrowForwardIcon fontSize="small" />
          </IconButton>
        </Stack>
        {actions || <Box />}
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: 'grey.100', minHeight: 300 }}>
        <Document
          file={url}
          onLoadSuccess={({ numPages: n }) => setNumPages(n)}
          loading={<CircularProgress size={32} />}
          error={<Typography color="error" variant="body2">無法載入 PDF</Typography>}
        >
          <Page
            pageNumber={pageNumber}
            width={width}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </Box>
    </Box>
  );
}
